<template>
  <div>
    <app-nav
      :full-name="userFullName" />
    <div class="columns">
      <div class="column"/>
      <div class="column is-four-fifths">
        <div
          v-if="factoryCode === ''"
          class="columns">

          <div class="column is-two-fifths">
            <form @submit.prevent="searchArticle">
              <b-field>
                <b-input
                  ref="articleIdInput"
                  v-model="articleIdSearch"
                  expanded
                  placeholder="Type or scan an article ID ..."
                  type="search"
                  icon="barcode" />
                <p class="control">
                  <button
                    type="submit"
                    class="button is-primary">Search</button>
                </p>
              </b-field>
            </form>
          </div>

          <div class="column is-two-fifths">
            <form @submit.prevent="searchFactoryNumber">
              <b-field>
                <b-input
                  v-model="factoryNumberSearch"
                  expanded
                  placeholder="Search a factory number ..."
                  type="search"
                  icon="magnify" />
                <p class="control">
                  <button
                    type="submit"
                    class="button is-primary">Search</button>
                </p>
              </b-field>
            </form>
          </div>

          <div class="column is-one-fifth">

            <router-link
              to="/article"
              class="button is-link is-outlined">
              <b-icon
                icon="plus" />
              <span>Create new article</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="column" />
    </div>

    <div class="columns">
      <div class="column"/>
      <div class="column is-four-fifths">
        <b-table
          ref="mainTable"
          :data="overviews"
          :per-page="itemsPerPage"
          default-sort="lastUpdated"
          default-sort-direction="desc"
          paginated
          pagination-size="is-small">

          <template slot-scope="props">
            <b-table-column
              field="articleId"
              label="Article"
              sortable>
              <router-link :to="'/articles/' + props.row.articleId">
                {{ formatArticleId(props.row.articleId, props.row.factoryCode) }}
              </router-link>
            </b-table-column>

            <b-table-column
              field="content"
              label="Content">
              {{ props.row.content }}
            </b-table-column>

            <b-table-column
              field="spec"
              label="Spec">
              {{ props.row.spec }}
            </b-table-column>

            <b-table-column
              field="width"
              label="Width">
              {{ props.row.width }}
            </b-table-column>

            <b-table-column
              field="weight"
              label="Weight">
              {{ props.row.weight }}
            </b-table-column>

          </template>

          <template slot="bottom-left">
            <b-select
              v-model="itemsPerPage"
              size="is-small"
              required>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </b-select>
          </template>
        </b-table>
      </div>
      <div class="column"/>
    </div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true" />
  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { getArticlesOverview, searchArticle } from '../utils/api'

export default {
  name: 'articles-overview',
  components: {
    AppNav
  },
  data() {
    return {
      overviews: [],
      userFullName: '',
      articleIdSearch: '',
      factoryNumberSearch: '',
      // loading
      isLoading: false,
      // table elements
      itemsPerPage: 20,
      factoryCode: ''
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.isLoading = true
        self.getArticlesOverview()
        self.userFullName = JSON.parse(getUser()).fullName
        self.isLoading = false
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    getArticlesOverview() {
      let self = this
      if (this.$route.params.factoryCode !== undefined) {
        this.factoryCode = this.$route.params.factoryCode
        let searchParam = { factoryCode: this.factoryCode }
        searchArticle(searchParam)
          .then(function(resp) {
            self.overviews = resp.data
          })
      } else {
        getArticlesOverview().then((overviews) => {
          this.overviews = overviews
          self.$refs.articleIdInput.focus()
        })
      }
    },
    formatArticleId(systemId, factoryCode) {
      return `TE-${factoryCode}-${systemId}`
    },
    searchArticle() {
      this.$router.push(`/articles/${this.articleIdSearch}`)
    },
    searchFactoryNumber() {
      let self = this
      let searchParam = { factoryNumber: this.factoryNumberSearch }
      searchArticle(searchParam)
        .then(function(resp) {
          let a = resp.data
          if (a !== undefined && a.articleId !== undefined && a.articleId !== '') {
            self.$toast.open({
              message: 'Article was found.',
              duration: 3000,
              position: 'is-top',
              type: 'is-success'
            })
            self.$router.push(`/articles/${a.articleId}`)
          } else {
            self.$toast.open({
              message: 'Failed to get article information.',
              duration: 3000,
              position: 'is-top',
              type: 'is-danger'
            })
          }
        }).catch(function() {
          self.$toast.open({
            message: 'Failed to get article information.',
            duration: 3000,
            position: 'is-top',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smaller {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticlesOverview.vue